import React from 'react';
import {
	InputAdornment,
	makeStyles,
	TextField,
	Theme,
	InputBaseComponentProps,
} from '@material-ui/core';
import { Control, FieldValues, DeepMap, FieldError, Controller } from 'react-hook-form';
import InputTooltip from 'components/tooltips/InputTooltips';
import { CustomInputRutMask, NumberFormatCustom } from 'utils/CustomFormatInput';
import { TextFieldLayoutItem } from 'models/InputLayoutItem';

const useStyles = makeStyles((theme: Theme) => ({
	input: {
		width: '100%',
		'& .MuiOutlinedInput-root': {
			backgroundColor: 'white',
		},
	},
}));

interface InputLayoutProps extends TextFieldLayoutItem {
	label: string;
	name: string;
	prefix?: string;
	tooltip?: string;
	mask?: string;
	control: Control<FieldValues>;
	errors: DeepMap<FieldValues, FieldError>;
};

export const InputLayout = ({
	label,
	name,
	placeholder,
	prefix,
	tooltip,
	mask,
	defaultValue,
	control,
	disabled,
	errors,
}: InputLayoutProps) => {
	const classes = useStyles();
	let inputMask: React.ElementType<InputBaseComponentProps>;

	if (mask !== undefined) {
		if (mask === 'rut') {
			inputMask = CustomInputRutMask as any;
		} else {
			inputMask = NumberFormatCustom as any;
		}
	}

	return (
		<>
			<Controller
				key={name}
				defaultValue={defaultValue}
				name={name}
				control={control}
				render={({ field }) => (
					<TextField
						{...field}
						disabled={disabled}
						color="primary"
						variant="outlined"
						label={label}
						placeholder={placeholder}
						className={classes.input}
						style={{ marginTop: 24 }}
						helperText={errors[name]?.message}
						error={errors[name] !== undefined}
						InputProps={{
							startAdornment: prefix ? (
								<InputAdornment position="start">{prefix} </InputAdornment>
							) : null,
							endAdornment: tooltip ? <InputTooltip title={tooltip} error={false} /> : null,
							inputComponent: inputMask,
							inputProps: mask !== undefined ? { format: mask } : undefined,
						}}
						InputLabelProps={{
							shrink: true,
						}}
					/>
				)}
			/>
		</>
	);
};
